<template>
  <div style="margin-bottom: 15px">
    <template v-if="isFile">
      <lxm-row :icon-class="iconClass(row)"
               :icon-mobile-class="iconMobileClass(row)"
               :mobile-check="mobileCheck(row)"
               :name="row.name"
               :value-site="'left'">
        <template v-for="item in row.files">
          <template v-if="item.value && item.valueLink">
            <p>
              <a target="_blank" :href="item.valueLink" >
                {{ item.value }}
              </a>
            </p>
          </template>
          <template v-if="item.image">
            <div class="lxm-row__content content">
              <p>
                <img class="lxm-row__content-image" style="width: 100%" :src="item.image" />
              </p>
            </div>
          </template>
        </template>
      </lxm-row>
    </template>
    <template v-else>
      <lxm-row :icon-class="iconClass(row)"
               :icon-mobile-class="iconMobileClass(row)"
               :mobile-check="mobileCheck(row)"
               :name="row.name"
               :image="row.image">
        <template v-if="row.value">
          <template v-if="row.type === 'tel'">
            <a :href="`tel:${row.value}`" >
              {{ row.value }}
            </a>
          </template>
          <template v-else-if="row.valueLink">
            <a target="_blank" :href="row.valueLink" >
              {{ row.value }}
            </a>
          </template>
          <template v-else-if="row.type === 'note_array'">
            <div v-if="row.value.length > 0">
              <div v-for="item in row.value">
                {{item}}
              </div>
            </div>
            <div v-else>无</div>
            <a v-if="row.is_show_more === 1" @click="record_notes_more(row.current_num)">查看更多</a>
          </template>
          <template v-else>
            {{ row.value }}
          </template>
        </template>
        <template v-if="row.content" slot="content">
          {{ row.content }}
        </template>
      </lxm-row>
    </template>
  </div>
</template>

<script>
  import LxmRow from './LxmRow.vue'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmRow
    },
    props: {
      row: Object
    },
    computed: {
      isFile: function () {
        return this.row.type === 'file' || this.row.type === 'draw_signature'
      }
    },
    methods: {
      iconClass (row) {
        let cls = ''
        if (row.icon) {
          cls = `lxm-row__img-icon lxm-row__img-icon--form-${row.icon}`
        }
        return cls
      },
      iconMobileClass (row) {
        if (!row.value) {
          return ''
        }

        if (row.smsCheck === '1') {
          if (row.mobileCheck === 1 || row.mobileCheck === '1') {
            return 'lxm-row__img-icon lxm-row__img-icon--cf-success'
          } else {
            return 'lxm-row__img-icon lxm-row__img-icon--main-close'
          }
        }
        return ''
      },
      mobileCheck (row) {
        // if (!row.value) {
        //   return ''
        // }
        //
        // if (row.smsCheck === '1') {
        //   if (row.mobileCheck === 1 || row.mobileCheck === '1') {
        //     return '手机号验证有效'
        //   } else {
        //     return '短信余量不足，该手机未验证'
        //   }
        // }
        return ''
      },
      record_notes_more (current_num) {
        this.$store.dispatch(aTypes.FORM_GET_RECORD_NOTES, {
          form_id: this.$route.query.formId,
          form_fill_id: this.$route.query.formfillId,
          current_num: current_num
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmFormRow.vue?0bc58176